<template>
  <div class="microfront-wrap">
    <!-- <div class="content" v-for="(item,index) in srcList" :key="index" v-show="item === active">
      <iframe class="content  iframe-content" :class="className" :src="item" frameborder="0"></iframe>
    </div> -->
  </div>
</template>

<script>
import { Base64 } from "js-base64";
import StringTool from "@/utils/stringTool";
export default {
  data() {
    return {
      srcList: [],
      active: "",
    };
  },
  computed:{
    // className(){
    //   return this.$store.state.data.theme
    // }
  },
  created() {
    console.log("1111111111111111111111")
    // const url = StringTool.escapeUrlOfStr(Base64.decode(this.$route.query.url));

    //   console.log(url);
    // this.srcList.push(url);
    // this.active = url;
  },
  watch: {
    // $route(to, from) {
    //   const url = StringTool.escapeUrlOfStr(Base64.decode(to.query.url));
    //   const item = this.srcList.find((obj) => obj === url);
    //   console.log(url);
    //   if (item) {
    //     this.active = url;
    //   } else {
    //     this.srcList.push(url);
    //     this.active = url;
    //   }
    // },
  },
};
</script>

<style lang="scss" scoped>
.microfront-wrap {
  width: 0px;
  height: 0px;
  background: #d5dadd;
}
.content {
  width: 100%;
  height: 100%;
}
</style>